export default "__VITE_ASSET__BiobDGsY__"